import { Component } from '@angular/core'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { FooterContainerComponent } from '../../../components/basic/footer-container/footer-container.component'
import { NavbarComponent } from '../../../components/revolution/navigation/navbar/navbar.component'
import { NavbarSecondComponent } from '../../../components/revolution/navigation/navbar-second/navbar-second.component'
import { RevolutionVehicleListComponent } from '../../../components/revolution/content/revolution-vehicle-list/revolution-vehicle-list.component'
import { DeleteVehicleComponent } from '../../../components/revolution/content/delete-vehicle/delete-vehicle.component'
import { RevolutionVehicleNavigationComponent } from '../../../components/revolution/vehicle-details/vehicle-navigation/vehicle-navigation.component'
@Component({
  selector: 'customer-portal-app-vehicles-view',
  standalone: true,
  templateUrl: './vehicles-view.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    FooterContainerComponent,
    NavbarComponent,
    NavbarSecondComponent,
    RevolutionVehicleListComponent,
    DeleteVehicleComponent,
    RevolutionVehicleNavigationComponent
  ]
})
export class VehiclesViewComponent {
  public hasNewFooter
  selectedVehicleStatusValue: string

  constructor (
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
  }

  onStatusChange (status: string): void {
    this.selectedVehicleStatusValue = status
  }
}
